import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/product',
          name: 'product',
          component: resolve => require(['@/view/Product'], resolve),
          meta: {
            title: '产品介绍'
          },
          children: []
        // }, {
        //   path: '/technology',
        //   name: 'technology',
        //   component: resolve => require(['@/view/Technology'], resolve),
        //   meta: {
        //     title: 'E行科技'
        //   }
        // }, {
        //   path: '/partnership',
        //   name: 'partnership',
        //   component: resolve => require(['@/view/Partnership'], resolve),
        //   meta: {
        //     title: '合作伙伴'
        //   }
        // },{
        //   path: '/cases',
        //   name: 'cases',
        //   component: resolve => require(['@/view/Cases'], resolve),
        //   meta: {
        //     title: '案例展示'
        //   }
        }, {
          path: '/join',
          name: 'join',
          component: resolve => require(['@/view/Join'], resolve),
          meta: {
            title: '招商加盟'
          }
        }, {
          path: '/aboutus',
          name: 'aboutus',
          component: resolve => require(['@/view/Aboutus'], resolve),
          meta: {
            title: '关于我们'
          }
        }, {
          path: "/news",
          name: 'news',
          component: resolve => require(['@/view/News'], resolve),
          meta: {
            title: '新闻资讯'
          }
        },{
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js